module.exports = __webpack_public_path__ + "static/media/userType.svg";